import { render, staticRenderFns } from "./HrSalaryRegistWorkarea.vue?vue&type=template&id=7d79bf96&scoped=true&"
import script from "./HrSalaryRegistWorkarea.vue?vue&type=script&lang=js&"
export * from "./HrSalaryRegistWorkarea.vue?vue&type=script&lang=js&"
import style0 from "./HrSalaryRegistWorkarea.vue?vue&type=style&index=0&id=7d79bf96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d79bf96",
  null
  
)

export default component.exports